import { Component, HostListener, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Profile } from 'src/_models/profile';
import { FileUploadService } from '../_services/fileupload.service';
import { ProfileService } from '../_services/profile.services';
import * as htmlToImage from 'html-to-image';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { fabric } from "fabric";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppConstants } from '../common/app.constants';

@Component({
  selector: 'app-convertImg',
  templateUrl: './convertImg.component.html',
  styleUrls: ['./convertImg.component.scss'],
})
export class ConvertImgComponent implements OnInit {

  subtitle: any
  profile: Profile = {
    content: '',
    postion: '',
    fullName: ''
  }
  profileUsers: Profile[] = []
  name = 'Angular';
  file: any = null;
  previewUrl: any = '';
  fileToUpload: any;
  imageUrl: any;
  fullName: any
  content: any
  form!: FormGroup;
  imageDownload: any
  imgHeightDownload: number = 0
  imgWidthDownload: number = 0
  overlayKyvong = '/assets/images/bg_overlay.png';
  backgroudKyvong = '/assets/images/background.png';
  backgroundImage: any = null;
  canvas: any;
  width: any = (window.innerWidth > 0) ? window.innerWidth : screen.width;
  height: any = (window.innerHeight > 0) ? window.innerHeight : screen.height;
  originBackend = AppConstants.API_URL2;


  constructor(private formBuilder: FormBuilder, private router: Router, private profileService: ProfileService,
    private modalService: NgbModal, private fileUploadService: FileUploadService) {
    // this.getListAllProfile();
  }

  ngOnInit() {
    this.canvas = new fabric.Canvas('canvas-kyvong', {
      width: 2000, height: 2000
    });
    var ratio = this.canvas.getWidth() / this.canvas.getHeight();
    if ((this.width / this.height) > ratio) {
      this.width = this.height * ratio;
    } else {
      this.height = this.width / ratio - 100;
      this.width = this.width / ratio - 100;
    }
    var scale = this.width / this.canvas.getWidth();
    var zoom = this.canvas.getZoom();
    zoom *= scale;
    this.canvas.setDimensions({
      width: this.width,
      height: this.width
    });
    this.canvas.setViewportTransform([zoom, 0, 0, zoom, 0, 0])
    // Use a single overlay image as the canvas background (one image is enough)
    // Load the overlay image and add it to the canvas (keeps it as a non-selectable layer)
    fabric.Image.fromURL(this.backgroudKyvong, (img) => {
      img.set({
        originX: 'left',
        originY: 'top',
        selectable: false,
        evented: false,
        hasControls: false,
        hasBorders: false,
        crossOrigin: 'anonymous'
      }).scale(0.9765);

  // Keep a reference so we can control stacking order later
  this.backgroundImage = img;
  this.canvas.add(this.backgroundImage);
      // ensure the background scales to the canvas width
      img.scaleToWidth(this.width);
  this.canvas.renderAll();

      // Now that background is present, resize the container and add text so text is above background
      this.resizeCanvas();
      this.addText();
    });
  }

  // getListAllProfile() {
  //   this.profileService.getAllProfile().subscribe(
  //     response => {
  //       this.profileUsers = response
  //       this.profileUsers.sort((a, b) => b.id - a.id)
  //     }, err => {

  //     }
  //   )
  // }

  resizeCanvas() {
    const outerCanvasContainer = document.getElementsByClassName("canvas-container")[0] as HTMLElement;
    if (outerCanvasContainer.clientWidth > 700) {
      outerCanvasContainer.style.width = "510";
      outerCanvasContainer.style.height = "510"
    } else {
      outerCanvasContainer.style.width = "auto";
      outerCanvasContainer.style.height = "".concat(outerCanvasContainer.clientWidth + "", "px");
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.resizeCanvas();
  }

  fileProgress(fileInput: any) {
    const file = <File>fileInput.target.files[0];
    const imageUpload = URL.createObjectURL(file);
    var zoom = this.canvas.getZoom();
    fabric.Image.fromURL(imageUpload, (oImg) => {
      oImg.scaleToWidth(600);
      oImg.set({
        left: 400,
        top: 100,
        cornerStyle: "circle",
        cornerColor: "red",
        cornerStrokeColor: "red",
        borderColor: "red",
        cornerSize: 15,

      });
      const scaleEl = document.getElementById('scaleImage') as HTMLInputElement | null;
      if (scaleEl) {
        scaleEl.addEventListener('input', (e: Event) => {
          const target = e.target as HTMLInputElement;
          const val = parseFloat(target.value || '100');
          oImg.scaleX = val / 100;
          oImg.scaleY = val / 100;
          this.canvas.requestRenderAll();
        }, false);
      }

      const angleEl = document.getElementById('angleImage') as HTMLInputElement | null;
      if (angleEl) {
        angleEl.addEventListener('input', (e: Event) => {
          const target = e.target as HTMLInputElement;
          const valued = parseInt(target.value || '0', 10);
          const angleParse = valued > 360 ? 360 : valued < 0 ? 0 : valued;
          this.canvas.item(0)['centeredRotation'] = true;
          oImg.set({
            angle: angleParse
          }).setCoords();
          this.canvas.renderAll();
        }, false);
      }
      this.canvas.add(oImg);
        this.canvas.renderAll();
        // Move uploaded image to bottom (index 0) so it is under the background
        try {
          // move uploaded image to index 0
          this.canvas.moveTo(oImg, 0);
          // ensure backgroundImage is above uploaded image
          if (this.backgroundImage) {
            this.canvas.moveTo(this.backgroundImage, 1);
          }
        } catch (e) {
          // ignore if operation fails
        }
        this.canvas.renderAll();
    });
  }

  addText() {
  var textboxHoTen = new fabric.Textbox(this.profile.fullName || '', {
      left: 200,
      top: 250,
      width: 1100,
      fontSize: 80,
      fontFamily: 'SVN-BANGO',
      cornerStrokeColor: '',
      fontWeight: 700,
      fill: '#ffffff',
      shadow:'2px 2px black',
      type: 'text',
      textAlign: 'center',
      hasControls: true,
      lockMovementX: false,
      lockMovementY: false,
      selected: true,
      selectable: true,
      moveCursor: 'none',
      hoverCursor: 'none'
    });
    const floatFullNameEl = document.getElementById('floatFullName') as HTMLInputElement | null;
    if (floatFullNameEl) {
      floatFullNameEl.addEventListener('input', (e: Event) => {
        const target = e.target as HTMLInputElement;
        textboxHoTen.set({
          text: target.value,
          type: "text"
        })
        this.canvas.requestRenderAll();
        this.exist = false;
      }, false);
    }
    this.canvas.add(textboxHoTen);
  }

  onSubmit(): void { }

  removeObject() {
    this.canvas.getActiveObjects().forEach((obj: any) => {
      this.canvas.remove(obj)
    });
    this.canvas.discardActiveObject().renderAll();
  }

  openModal(exampleModalContent: any) {
    const windowWidth = window.screen.width
    if (windowWidth >= 576) {
      this.imgWidthDownload = 466;
      this.imgHeightDownload = 466;
    } else {
      this.imgWidthDownload = windowWidth - 53;
      this.imgHeightDownload = windowWidth - 53;
    }
    var multiplier = 2000 / this.width
    this.imageDownload = this.canvas.toDataURL({
      format: "png",
      quality: 1,
      multiplier: multiplier
    });
    this.modalService.open(exampleModalContent, { size: 'md' });
  }

  async downloadImage() {
    const a = document.createElement('a');
    var multiplier = 2000 / this.width
    console.log("multiplier " + multiplier)
    this.canvas.renderAll();
    a.href = this.canvas.toDataURL({
      format: "png",
      quality: 1,
      multiplier: multiplier
    });
    a.download = 'ky-vong-dai-hoi.png';
    document.body.appendChild(a);
    a.click();
  }

  exist: boolean = false;

  saveImageDB(update: boolean) {
    var multiplier = 2000 / this.width
    const base64 = this.canvas.toDataURL({
      format: "png",
      quality: 1,
      multiplier: multiplier
    });
    var block = base64.split(";");
    var contentType = block[0].split(":")[1];// In this case "image/gif"
    var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
    var blob = this.b64toBlob(realData, contentType, 0);
    const imageName = 'banner_store.png';
    const imageFile = new File([blob], imageName);
    const formData = new FormData();

    // this.profileService.addProfile(this.profile, update).subscribe(
    //   response => {
    //     if (response.error) {
    //       this.exist = true;
    //     } else {
    //       let id = response.resultData.id;
    //       formData.append('profileUserId', id);
    //       formData.append('upload', imageFile);
    //       this.fileUploadService.uploadImage(formData).subscribe(
    //         response => {
    //           // this.getListAllProfile()
    //         }, err => {
    //         }
    //       )
    //       this.modalService.dismissAll();
    //     }
    //   }, err => {
    //   }
    // )
    if (update) {
      this.downloadImage()
    }
  }

  b64toBlob(b64Data: string, contentType: string, sliceSize: number) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

}
